import React from "react";
import useChange from "src/utils/hooks/useChange";
import ArrowUp from "src/icons/ArrowUp";
import ArrowDown from "src/icons/ArrowDown";

interface GainsOrLosesProps {
  balance: number | null;
}

const GainsOrLoses = (props: GainsOrLosesProps) => {
  const { balance } = props;
  const { flag, change } = useChange(balance);
  const gains = {
    color: "#10B981",
    fontSize: "14px",
  };

  const loses = {
    color: "#EA0C01",
    fontSize: "14px",
  };

  return (
    <span translate="no">
      {flag === "bullish" && (
        <span>
          <ArrowUp />
          <span style={gains}>{` ${change}`}%</span>
        </span>
      )}
      {flag === "bearish" && (
        <span>
          <ArrowDown />
          <span style={loses}>{` ${change}`}%</span>
        </span>
      )}
      {flag === "neutral" && <span>{change}</span>}
      {flag === "error" && <span>-</span>}
    </span>
  );
};

export default GainsOrLoses;
